import { Box, Typography } from '@mui/material';
import { commitTransaction, getTransaction } from 'lib/api/express/transaction';
import { TransactionProvider } from 'lib/api/express/transaction/types';
import Webpay from 'lib/common/Transaction/Metadata/Webpay';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'services/redux/store';
import { clearTransaction } from 'services/redux/transaction';

const Commit = () => {
  const dispatch = useDispatch();
  const domain = window.location.hostname;
  const secretId = domain.split('.')[0];
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const { transaction, originUrl } = useSelector(
    (state: RootState) => state.transaction,
  );

  if (!transaction) return <div>No transaction found</div>;

  const { data, isPending, isError } = getTransaction(
    dispatch,
    secretId,
    transaction.id,
  );
  const { mutate, isPending: isCommitting } = commitTransaction(
    dispatch,
    secretId,
  );

  const handleReturn = () => {
    if (!originUrl) return;
    window.location.href = originUrl;
    setTimeout(() => {
      dispatch(clearTransaction());
    }, 1000);
  };

  const MetadataView = useMemo(() => {
    switch (data?.provider) {
      case TransactionProvider.WEBPAY:
        return <Webpay data={data} handleReturn={handleReturn} />;
      default:
        return null;
    }
  }, [data]);

  useEffect(() => {
    if (params.get('TBK_TOKEN')) {
      return showAlert(dispatch, 'error', 'La transacción ha sido rechazada');
    }
    mutate(transaction.id);
  }, [transaction.id]);

  if (isPending || isCommitting)
    return <CenteredCircularProgress type="layout" />;

  if (isError || !data) {
    return (
      <Typography color="error" align="center">
        No fue posible obtener el detalle de la transacción.
      </Typography>
    );
  }

  return <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>{MetadataView}</Box>;
};

export default Commit;
